import React from "react";
import "../css/payment.css";
import CuDropdown from "../../common_component/component/CuDropdown";
import InputField from "../../common_component/component/InputField";
import moment from "moment";
import { ADD_ICON, RED_CLOSE_ICON } from "../../cufront-assets/icons/Icons";

const options = [{ key: 1, value: "Paid", text: "Paid" }];

const Payment = ({
  payment,
  createBlankPayment,
  handlePaymentChange,
  idx,
  paymentOptions,
  isView,
  invoiceStatus,
  deletePayment,
}) => {
  const getDeleteCondition = (paymentId) => {
    if (invoiceStatus === "draft") {
      return true;
    }
    if (invoiceStatus === "published" && !paymentId) {
      return true;
    }
    return false;
  };

  const transactionDate = payment?.transaction_date
    ? moment(payment?.transaction_date).format("YYYY-MM-DD")
    : "";

  return (
    <div>
      <div className="cu-payment-input-cont">
        <div>
          <label>Status</label>
          <CuDropdown
            options={options}
            value={payment?.status}
            onChange={(val) => handlePaymentChange(val, "status", idx)}
            disabled={isView}
          />
        </div>
        <div>
          <div>Date</div>
          <InputField
            type={"date"}
            id={"payment"}
            value={transactionDate}
            onChange={(e) =>
              handlePaymentChange(e.target.value, "transaction_date", idx)
            }
            disabled={isView}
          />
        </div>
        <div>
          <div>Type</div>
          <CuDropdown
            options={paymentOptions}
            value={payment?.payment_mode?.id}
            onChange={(val) =>
              handlePaymentChange({ id: val }, "payment_mode", idx)
            }
            disabled={isView}
          />
        </div>
        <div className="cu-payment-description">
          <InputField
            type={"text"}
            placeholder={"select"}
            label={"Description"}
            value={payment?.transaction_details}
            onChange={(e) =>
              handlePaymentChange(e.target.value, "transaction_details", idx)
            }
            disabled={isView}
          />
        </div>
        <div>
          <InputField
            type={"number"}
            placeholder={"select"}
            label={"Amount"}
            value={payment?.received_payment}
            disabled={isView}
            onChange={(e) =>
              handlePaymentChange(e.target.value, "received_payment", idx)
            }
          />
        </div>
        <div className="cu-add-payment-invoice">
          {getDeleteCondition(payment?.id) && (
            <span onClick={() => deletePayment(idx)}>
              <img
                src={RED_CLOSE_ICON}
                alt="close"
                width={"28px"}
                height={"28px"}
              />
            </span>
          )}
          <span onClick={createBlankPayment}>
            <img src={ADD_ICON} alt="add" width={"28px"} height={"28px"} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Payment;
